// extracted by mini-css-extract-plugin
export default {"cls1":"SRhTxeDmUx70Ool0zXVY","cls2":"TPUtQudGXcrvM8tCNHRs SRhTxeDmUx70Ool0zXVY","hasCancellationPolicy":"ZNw40pAEE4u7UtJyI1Hw"};